var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTriangleRight = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.50391 1.79911C3.50391 0.920935 4.5548 0.469222 5.19201 1.07349L11.7309 7.27439C12.1468 7.66875 12.1468 8.33125 11.7309 8.72561L5.19201 14.9265C4.5548 15.5308 3.50391 15.0791 3.50391 14.2009L3.50391 1.79911Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTriangleRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/triangleRight.d521607acf8f99bad3162b17dbb5aa9e.svg";